import { Link, useSearchParams } from "react-router-dom";
import { useEffect, useMemo } from "react";
import { eventStatusLabels } from "../../domain/operations";
import { useOperations } from "../../state/OperationsProvider";
import { EventLifecycleTabs } from "./EventLifecycleTabs";
import { eventMatchesLifecycle, resolveEventLifecycleFilter } from "./eventLifecycle";

export function EventsListPage() {
  const { snapshot } = useOperations();
  const [searchParams, setSearchParams] = useSearchParams();
  const lifecycle = resolveEventLifecycleFilter(searchParams.get("status"));

  useEffect(() => {
    if (!searchParams.get("status")) {
      setSearchParams({ status: "confirmed" }, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const filteredEvents = useMemo(() => {
    if (!snapshot) return [];
    return snapshot.events.filter((event) => eventMatchesLifecycle(event, lifecycle, snapshot));
  }, [lifecycle, snapshot]);

  if (!snapshot) return null;

  return (
    <>
      <section className="desktop-view events-page">
        <EventLifecycleTabs snapshot={snapshot} />
        <div className="events-list">
          {filteredEvents.map((event) => (
            <Link key={event.id} className={`event-list-card ${event.status}`} to={`/events/${event.id}`}>
              <i className={`event-dot ${event.color}`} />
              <div>
                <strong>{event.name}</strong>
                <small>{event.type} · {event.dateLabel} · {event.location}</small>
              </div>
              <span className={`status-pill ${event.status}`}>{eventStatusLabels[event.status]}</span>
              <span aria-hidden="true">›</span>
            </Link>
          ))}
        </div>
      </section>
      <section className="mobile-view events-mobile events-page">
        <EventLifecycleTabs snapshot={snapshot} />
        {filteredEvents.map((event) => (
          <Link key={event.id} className={`work-block-link ${event.status}`} to={`/events/${event.id}`}>
            <span className={`location-icon ${event.color}`}><i className={`event-dot ${event.color}`} /></span>
            <span><strong>{event.name}</strong><small>{eventStatusLabels[event.status]} · {event.dateLabel}</small></span>
            <span>›</span>
          </Link>
        ))}
        <div className="mobile-space" />
      </section>
    </>
  );
}
